import React from 'react';
import PropTypes from 'prop-types';
import EditName from '../users/EditName';

const UserHeader = ({ user, persona, storefront, onToggleActive, onEditName, localized, userActions }) => {
    return (
        <div className="info">
            <div className="title flex">
                <div className="d-flex align-items-center gap-2">
                    <div className="name">
                        {user?.firstName && user?.lastName ? `${user.firstName} ${user.lastName}` : 'N/A'}
                    </div>
                    <EditName
                        isAdmin={true}
                        userActions={userActions}
                        updateFullNameState={onEditName}
                        user={user}
                        localized={localized}
                    />
                </div>
                <div className="toggle">
                    <span className="label">
                        {user.isActive ? localized.ActiveLabel : localized.InactiveLabel}:
                    </span>
                    <button
                        className={`fele-status-toggle ${user.isActive ? '' : 'inactive'}`}
                        onClick={onToggleActive}
                    >
                        <div className="switch"></div>
                    </button>
                </div>
            </div>
        </div>
    );
};

UserHeader.propTypes = {
    user: PropTypes.object.isRequired,
    persona: PropTypes.object,
    storefront: PropTypes.object,
    onToggleActive: PropTypes.func.isRequired,
    onEditName: PropTypes.func.isRequired,
    localized: PropTypes.object.isRequired,
    userActions: PropTypes.object.isRequired,
    isAdmin: PropTypes.bool.isRequired
};

export default UserHeader;
